import type { FitnessScoreApiResponse } from "@/src/features/api/ChatApi";
import type { OnboardingV3FitnessScore } from "./onboardingV3Types";

function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

/** ChatApi fitnessScore → onboarding session 类型；无效输入视为无分（AC-06） */
export function normalizeFitnessScore(
  raw?: FitnessScoreApiResponse | null,
): OnboardingV3FitnessScore | undefined {
  if (!raw) {
    return undefined;
  }

  const { total, control, safety, growth, headline, scoreBasis } = raw;

  if (
    !isFiniteNumber(total) ||
    !isFiniteNumber(control) ||
    !isFiniteNumber(safety) ||
    !isFiniteNumber(growth) ||
    typeof headline !== "string" ||
    !headline.trim() ||
    typeof scoreBasis !== "string" ||
    !scoreBasis.trim()
  ) {
    return undefined;
  }

  return {
    total,
    control,
    safety,
    growth,
    partial: raw.partial,
    headline: headline.trim(),
    scoreBasis: scoreBasis.trim(),
  };
}
